import {CssColor, StyleType, wixColor} from '@wix/editor-platform-ooi-metadata-resolver'
import {
  ISiteTextPreset,
  IWixStyleFont,
  StyleParamType,
  createStylesParam,
  createStylesParams,
  wixColorParam,
  wixFontParam,
} from '@wix/tpa-settings'
import {
  EventDetailsAlignment,
  EventDetailsButtonStyle,
  EventDetailsImageRatio,
  HEADER_IMAGE_ALIGNMENT,
  HEADER_LAYOUT,
  IMAGE_SCALING,
  TICKET_PICKER_LAYOUT,
} from '@wix/wix-events-commons-statics'
import {Override} from '../../commons/types/utils'
import {PageComponentTextSettings} from './settingsParams'
import {getV2FontDefault} from './Widget/utils/css-per-breakpoint'

type IBooleans = {
  shortDateLocationVisible: StyleParamType.Boolean
  descriptionVisible: StyleParamType.Boolean
  membersVisible: StyleParamType.Boolean
  membershipsVisible: StyleParamType.Boolean
  groupVisible: StyleParamType.Boolean
  aboutSectionVisible: StyleParamType.Boolean
  scheduleVisible: StyleParamType.Boolean
  ticketMoreInfoButtonVisible: StyleParamType.Boolean
  mapVisible: StyleParamType.Boolean
  socialShareVisible: StyleParamType.Boolean
  readMoreButtonVisible: StyleParamType.Boolean
  headerRegistrationButtonVisible: StyleParamType.Boolean
  pageRegistrationButtonVisible: StyleParamType.Boolean
  ticketPickerCardsShadowVisible: StyleParamType.Boolean
  responsive: StyleParamType.Boolean
  eventImageVisible: StyleParamType.Boolean
}

type INumbers = {
  headerLayout: StyleParamType.Number
  headerImageAlignment: StyleParamType.Number
  headerBorderWidth: StyleParamType.Number
  evTicketDividerSize: StyleParamType.Number
  rsvpButtonBorderWidth: StyleParamType.Number
  rsvpButtonBorderRadius: StyleParamType.Number
  rsvpButtonRoundedBorderRadius: StyleParamType.Number
  formButtonBorderWidth: StyleParamType.Number
  formButtonBorderRadius: StyleParamType.Number
  formButtonRoundedBorderRadius: StyleParamType.Number
  formSummaryBoxBorderSize: StyleParamType.Number
  imageOpacity: StyleParamType.Number
  buttonStyle: StyleParamType.Number
  imageRatio: StyleParamType.Number
  imageScaling: StyleParamType.Number
  headerAlignment: StyleParamType.Number
  contentAlignment: StyleParamType.Number
  formButtonStyle: StyleParamType.Number
  ticketPickerLayout: StyleParamType.Number
  ticketPickerListSpacing: StyleParamType.Number
  ticketPickerCardSpacing: StyleParamType.Number
  ticketPickerListVerticalDividerWidth: StyleParamType.Number
  ticketPickerCardsVerticalDividerWidth: StyleParamType.Number
  ticketPickerListHorizontalDividerWidth: StyleParamType.Number
  ticketPickerCardsBorderWidth: StyleParamType.Number
  ticketPickerCardsBorderRadius: StyleParamType.Number
  ticketPickerCardsShadowAngle: StyleParamType.Number
  ticketPickerCardsShadowDistance: StyleParamType.Number
  ticketPickerCardsShadowBlur: StyleParamType.Number
  mobileShortDateTimeSize: StyleParamType.Number
  mobileEventTitleSize: StyleParamType.Number
  mobileDescriptionSize: StyleParamType.Number
  mobileButtonTextSize: StyleParamType.Number
  mobileSubtitlesSize: StyleParamType.Number
  mobileTextSize: StyleParamType.Number
  mobileScheduleTimeSize: StyleParamType.Number
  mobileScheduleDurationSize: StyleParamType.Number
  mobileScheduleTitleSize: StyleParamType.Number
  mobileScheduleLocationSize: StyleParamType.Number
  mobileTicketsPickerTicketNameSize: StyleParamType.Number
  mobileTicketsPickerMainFontSize: StyleParamType.Number
  mobileTicketsPickerAdditionalFontSize: StyleParamType.Number
  ticketPickerListInputBorderRadius: StyleParamType.Number
  ticketPickerCardsInputBorderRadius: StyleParamType.Number
}

type IStyles = {
  shortDateLocationFont: StyleParamType.Font
  shortDateLocationColor: StyleParamType.Color
  descriptionFont: StyleParamType.Font
  descriptionColor: StyleParamType.Color
  titleFont: StyleParamType.Font
  titleColor: StyleParamType.Color
  subtitlesFont: StyleParamType.Font
  subtitlesColor: StyleParamType.Color
  textFont: StyleParamType.Font
  textColor: StyleParamType.Color
  evTicketNameFont: StyleParamType.Font
  evTicketNameColor: StyleParamType.Color
  ticketPickerListMainFont: StyleParamType.Font
  ticketPickerCardsMainFont: StyleParamType.Font
  ticketPickerListMainColor: StyleParamType.Color
  ticketPickerCardsMainColor: StyleParamType.Color
  ticketPickerListAdditionalFont: StyleParamType.Font
  ticketPickerCardsAdditionalFont: StyleParamType.Font
  ticketPickerListAdditionalColor: StyleParamType.Color
  ticketPickerCardsAdditionalColor: StyleParamType.Color
  ticketPickerCardsBackgroundColor: StyleParamType.Color
  ticketPickerCardsBorderColor: StyleParamType.Color
  ticketPickerCardsVerticalDividerColor: StyleParamType.Color
  ticketPickerCardsShadowColor: StyleParamType.Color
  ticketPickerListVerticalDividerColor: StyleParamType.Color
  ticketPickerListHorizontalDividerColor: StyleParamType.Color
  scheduleTimeFont: StyleParamType.Font
  scheduleTimeColor: StyleParamType.Color
  scheduleDurationFont: StyleParamType.Font
  scheduleDurationColor: StyleParamType.Color
  scheduleTitleFont: StyleParamType.Font
  scheduleTitleColor: StyleParamType.Color
  scheduleLocationFont: StyleParamType.Font
  scheduleLocationColor: StyleParamType.Color
  headerBackgroundColor: StyleParamType.Color
  evBackgroundColor: StyleParamType.Color
  headerBorderOpacityAndColor: StyleParamType.Color
  colorBehindImage: StyleParamType.Color
  rsvpHollowButtonColor: StyleParamType.Color
  rsvpButtonBorderColor: StyleParamType.Color
  secondRsvpHollowButtonColor: StyleParamType.Color
  secondRsvpButtonBorderColor: StyleParamType.Color
  rsvpHollowButtonFont: StyleParamType.Font
  secondRsvpHollowButtonFont: StyleParamType.Font
  secondRsvpButtonFont: StyleParamType.Font
  rsvpButtonFont: StyleParamType.Font
  rsvpButtonBackgroundColor: StyleParamType.Color
  secondRsvpButtonColor: StyleParamType.Color
  secondRsvpButtonBackgroundColor: StyleParamType.Color
  formSummaryTitleFont: StyleParamType.Font
  formSummaryBodyFont: StyleParamType.Font
  formSummaryBodyColor: StyleParamType.Color
  formSummaryColor: StyleParamType.Color
  formSummaryBoxBackgroundColor: StyleParamType.Color
  formSummaryBoxBorderColor: StyleParamType.Color
  formTitleFont: StyleParamType.Font
  formTitleColor: StyleParamType.Color
  formLabelsFont: StyleParamType.Font
  formLabelsColor: StyleParamType.Color
  formBackgroundColor: StyleParamType.Color
  formHollowButtonFont: StyleParamType.Font
  formHollowButtonColor: StyleParamType.Color
  formButtonBorderColor: StyleParamType.Color
  formButtonBackgroundColor: StyleParamType.Color
  formFullButtonColor: StyleParamType.Color
  formFullButtonFont: StyleParamType.Font
  linksColor: StyleParamType.Color
  headerDateColorV2: StyleParamType.Color
  headerDateFontV2: StyleParamType.Font
  headerLocationFontV2: StyleParamType.Font
  headerLocationColorV2: StyleParamType.Color
  dateColorV2: StyleParamType.Color
  dateFontV2: StyleParamType.Font
  locationColorV2: StyleParamType.Color
  locationFontV2: StyleParamType.Font
  linkFontV2: StyleParamType.Font
  linkColorV2: StyleParamType.Color
  socialShareColorV2: StyleParamType.Color
  textFontV2: StyleParamType.Font
  textColorV2: StyleParamType.Color
  aboutSectionFontV2: StyleParamType.Font
  aboutSectionColorV2: StyleParamType.Color
  titleFontV2: StyleParamType.Font
  descriptionFontV2: StyleParamType.Font
  rsvpHollowButtonFontV2: StyleParamType.Font
  rsvpButtonFontV2: StyleParamType.Font
  subtitlesFontV2: StyleParamType.Font
  scheduleTimeFontV2: StyleParamType.Font
  scheduleDurationFontV2: StyleParamType.Font
  scheduleTitleFontV2: StyleParamType.Font
  scheduleLocationFontV2: StyleParamType.Font
  ticketPickerListMainFontV2: StyleParamType.Font
  ticketPickerCardsMainFontV2: StyleParamType.Font
  ticketPickerListAdditionalFontV2: StyleParamType.Font
  ticketPickerCardsAdditionalFontV2: StyleParamType.Font
  formTitleFontV2: StyleParamType.Font
  formHollowButtonFontV2: StyleParamType.Font
  formFullButtonFontV2: StyleParamType.Font
  formLinksColor: StyleParamType.Color
  rsvpButtonColor: StyleParamType.Color
}

export type IStylesParams = INumbers & IBooleans & IStyles

export type PageComponentSettings = Override<INumbers, number> &
  Override<IBooleans, boolean> & {texts: PageComponentTextSettings}

type ParamsMapper<Type, Val> = {
  [Property in keyof Type]: Val
}

export type DetailsStyleParams = {
  numbers: ParamsMapper<INumbers, number>
  booleans: ParamsMapper<IBooleans, boolean> & {responsive: boolean; __IS_RTL__: boolean}
  colors: IStyles
  fonts: IStyles
  strings: any
}

const getDefaultFont = (name: keyof ISiteTextPreset, options: Partial<IWixStyleFont> = {}) => {
  return ({textPresets}: {textPresets: ISiteTextPreset}) => {
    const {value: _, ...font} = wixFontParam(name, options)({textPresets})
    return font as IWixStyleFont
  }
}

const textColor = createStylesParam('textColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-5'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
})
const textFont = createStylesParam('textFont', {
  type: StyleParamType.Font,
  getDefaultValue: getDefaultFont('Body-M', {
    size: 16,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 16,
    },
    mobileDefaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 14,
    },
  },
})

const linksColor = createStylesParam('linksColor', {
  type: StyleParamType.Color,
  getDefaultValue: ({getStyleParamValue}) => {
    if (
      [EventDetailsButtonStyle.HOLLOW, EventDetailsButtonStyle.HOLLOW_ROUNDED].includes(getStyleParamValue(buttonStyle))
    ) {
      return getStyleParamValue(secondRsvpButtonBorderColor)
    } else {
      return getStyleParamValue(secondRsvpButtonBackgroundColor)
    }
  },
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
  },
})

const textFontV2 = createStylesParam('textFontV2', {
  type: StyleParamType.Font,
  getDefaultValue: params =>
    getV2FontDefault({
      params,
      fontParam: textFont,
      mobileSizeOverrideParam: mobileTextSize,
      defaults: {fontSize: 16, mobileFontSize: 14},
    }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'ref',
      ref: 'textFont',
    },
  },
})

const textColorV2 = createStylesParam('textColorV2', {
  type: StyleParamType.Color,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(textColor),
  metadata: {
    type: StyleType.color,
    defaultValue: {
      type: 'ref',
      ref: 'textColor',
    },
  },
})

const evTicketNameColor = createStylesParam('evTicketNameColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-5'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
})
const evTicketNameFont = createStylesParam('evTicketNameFont', {
  type: StyleParamType.Font,
  getDefaultValue: getDefaultFont('Body-M', {
    size: 20,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 20,
    },
  },
})

const evBackgroundColor = createStylesParam('evBackgroundColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-1'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
  },
})

const mobileTicketsPickerTicketNameSize = createStylesParam('mobileTicketsPickerTicketNameSize', {
  type: StyleParamType.Number,
  getDefaultValue: () => 20,
})

const secondRsvpButtonBackgroundColor = createStylesParam('secondRsvpButtonBackgroundColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-8'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
  },
})

const buttonStyle = createStylesParam('buttonStyle', {
  type: StyleParamType.Number,
  getDefaultValue: () => EventDetailsButtonStyle.FULL,
})

const mobileButtonTextSize = createStylesParam('mobileButtonTextSize', {
  type: StyleParamType.Number,
  getDefaultValue: () => 16,
})

const rsvpHollowButtonFont = createStylesParam('rsvpHollowButtonFont', {
  type: StyleParamType.Font,
  getDefaultValue: getDefaultFont('Body-M', {
    size: 16,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 16,
    },
  },
})

const rsvpButtonFont = createStylesParam('rsvpButtonFont', {
  type: StyleParamType.Font,
  getDefaultValue: getDefaultFont('Body-M', {
    size: 16,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 16,
    },
  },
})

const secondRsvpButtonBorderColor = createStylesParam('secondRsvpButtonBorderColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-8'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
  },
})

const formSummaryColor = createStylesParam('formSummaryColor', {
  type: StyleParamType.Color,
  getDefaultValue: wixColorParam('color-5'),
  metadata: {
    type: StyleType.color,
    defaultValue: wixColor(CssColor.WstParagraph2Color),
  },
})

const shortDateLocationFont = createStylesParam('shortDateLocationFont', {
  type: StyleParamType.Font,
  getDefaultValue: getDefaultFont('Body-M', {
    size: 18,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 18,
    },
    mobileDefaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 14,
    },
  },
})

const mobileShortDateTimeSize = createStylesParam('mobileShortDateTimeSize', {
  type: StyleParamType.Number,
  getDefaultValue: () => 14,
})

const mobileTextSize = createStylesParam('mobileTextSize', {
  type: StyleParamType.Number,
  getDefaultValue: () => 14,
})

const mobileEventTitleSize = createStylesParam('mobileEventTitleSize', {
  type: StyleParamType.Number,
  getDefaultValue: () => 28,
})

const mobileDescriptionSize = createStylesParam('mobileDescriptionSize', {
  type: StyleParamType.Number,
  getDefaultValue: () => 14,
})

const mobileSubtitlesSize = createStylesParam('mobileSubtitlesSize', {
  type: StyleParamType.Number,
  getDefaultValue: () => 20,
})

const mobileScheduleTimeSize = createStylesParam('mobileScheduleTimeSize', {
  type: StyleParamType.Number,
  getDefaultValue: () => 14,
})

const mobileScheduleDurationSize = createStylesParam('mobileScheduleDurationSize', {
  type: StyleParamType.Number,
  getDefaultValue: () => 14,
})

const mobileScheduleTitleSize = createStylesParam('mobileScheduleTitleSize', {
  type: StyleParamType.Number,
  getDefaultValue: () => 14,
})

const mobileScheduleLocationSize = createStylesParam('mobileScheduleLocationSize', {
  type: StyleParamType.Number,
  getDefaultValue: () => 14,
})

const mobileTicketsPickerMainFontSize = createStylesParam('mobileTicketsPickerMainFontSize', {
  type: StyleParamType.Number,
  getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(mobileTicketsPickerTicketNameSize) ?? 20,
})

const mobileTicketsPickerAdditionalFontSize = createStylesParam('mobileTicketsPickerAdditionalFontSize', {
  type: StyleParamType.Number,
  getDefaultValue: () => 14,
})

const titleFont = createStylesParam('titleFont', {
  type: StyleParamType.Font,
  getDefaultValue: getDefaultFont('Page-title', {
    size: 60,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Page-title',
      size: 60,
    },
    mobileDefaultValue: {
      type: 'static',
      preset: 'Page-title',
      size: 28,
    },
  },
})

const descriptionFont = createStylesParam('descriptionFont', {
  type: StyleParamType.Font,
  getDefaultValue: getDefaultFont('Body-M', {
    size: 16,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 16,
    },
    mobileDefaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 14,
    },
  },
})

const rsvpHollowButtonFontV2 = createStylesParam('rsvpHollowButtonFontV2', {
  type: StyleParamType.Font,
  getDefaultValue: params =>
    getV2FontDefault({
      params,
      fontParam: rsvpHollowButtonFont,
      mobileSizeOverrideParam: mobileButtonTextSize,
      defaults: {fontSize: 16, mobileFontSize: 16},
    }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 16,
    },
  },
})

const rsvpButtonFontV2 = createStylesParam('rsvpButtonFontV2', {
  type: StyleParamType.Font,
  getDefaultValue: params =>
    getV2FontDefault({
      params,
      fontParam: rsvpButtonFont,
      mobileSizeOverrideParam: mobileButtonTextSize,
      defaults: {fontSize: 16, mobileFontSize: 16},
    }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 16,
    },
  },
})

const subtitlesFont = createStylesParam('subtitlesFont', {
  type: StyleParamType.Font,
  getDefaultValue: getDefaultFont('Page-title', {
    size: 30,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Page-title',
      size: 30,
    },
    mobileDefaultValue: {
      type: 'static',
      preset: 'Page-title',
      size: 20,
    },
  },
})

const scheduleTimeFont = createStylesParam('scheduleTimeFont', {
  type: StyleParamType.Font,
  getDefaultValue: getDefaultFont('Body-M', {
    size: 16,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 16,
    },
    mobileDefaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 14,
    },
  },
})

const scheduleDurationFont = createStylesParam('scheduleDurationFont', {
  type: StyleParamType.Font,
  getDefaultValue: getDefaultFont('Body-M', {
    size: 14,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 14,
    },
  },
})

const scheduleTitleFont = createStylesParam('scheduleTitleFont', {
  type: StyleParamType.Font,
  getDefaultValue: getDefaultFont('Body-M', {
    size: 16,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 16,
    },
    mobileDefaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 14,
    },
  },
})

const scheduleLocationFont = createStylesParam('scheduleLocationFont', {
  type: StyleParamType.Font,
  getDefaultValue: getDefaultFont('Body-M', {
    size: 14,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 14,
    },
  },
})

const ticketPickerListMainFont = createStylesParam('ticketPickerListMainFont', {
  type: StyleParamType.Font,
  getDefaultValue: ({getStyleParamValue}) => ({
    ...getStyleParamValue(evTicketNameFont),
    size: 20,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'ref',
      ref: 'evTicketNameFont',
    },
  },
})

const ticketPickerCardsMainFont = createStylesParam('ticketPickerCardsMainFont', {
  type: StyleParamType.Font,
  getDefaultValue: ({getStyleParamValue}) => ({
    ...getStyleParamValue(evTicketNameFont),
    size: 20,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'ref',
      ref: 'evTicketNameFont',
    },
  },
})

const ticketPickerListAdditionalFont = createStylesParam('ticketPickerListAdditionalFont', {
  type: StyleParamType.Font,
  getDefaultValue: ({getStyleParamValue}) => ({
    ...getStyleParamValue(textFont),
    size: 14,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 14,
    },
  },
})

const ticketPickerCardsAdditionalFont = createStylesParam('ticketPickerCardsAdditionalFont', {
  type: StyleParamType.Font,
  getDefaultValue: ({getStyleParamValue}) => ({
    ...getStyleParamValue(textFont),
    size: 14,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 14,
    },
  },
})

const formTitleFont = createStylesParam('formTitleFont', {
  type: StyleParamType.Font,
  getDefaultValue: getDefaultFont('Body-M', {
    size: 30,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 30,
    },
  },
})

const formHollowButtonFont = createStylesParam('formHollowButtonFont', {
  type: StyleParamType.Font,
  getDefaultValue: getDefaultFont('Body-M', {
    size: 16,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 16,
    },
  },
})

const formFullButtonFont = createStylesParam('formFullButtonFont', {
  type: StyleParamType.Font,
  getDefaultValue: getDefaultFont('Body-M', {
    size: 16,
  }),
  metadata: {
    type: StyleType.font,
    defaultValue: {
      type: 'static',
      preset: 'Body-M',
      size: 16,
    },
  },
})

const stylesParams = createStylesParams<IStylesParams>({
  mobileButtonTextSize,
  formHollowButtonFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: formHollowButtonFont,
        defaults: {fontSize: 16, mobileFontSize: 16, staticMobileSize: true},
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'formHollowButtonFont',
      },
    },
  },
  formFullButtonFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: formFullButtonFont,
        defaults: {fontSize: 16, mobileFontSize: 16, staticMobileSize: true},
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'formFullButtonFont',
      },
    },
  },
  formTitleFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: formTitleFont,
        defaults: {fontSize: 30, mobileFontSize: 20, staticMobileSize: true},
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 30,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 20,
      },
    },
  },
  titleFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: titleFont,
        mobileSizeOverrideParam: mobileEventTitleSize,
        defaults: {
          preset: 'Page-title',
          fontSize: 60,
          mobileFontSize: 28,
        },
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Page-title',
        size: 60,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: 'Page-title',
        size: 28,
      },
    },
  },
  descriptionFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: descriptionFont,
        mobileSizeOverrideParam: mobileDescriptionSize,
        defaults: {fontSize: 16, mobileFontSize: 14},
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  subtitlesFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: subtitlesFont,
        mobileSizeOverrideParam: mobileSubtitlesSize,
        defaults: {
          preset: 'Page-title',
          fontSize: 30,
          mobileFontSize: 20,
        },
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Page-title',
        size: 30,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: 'Page-title',
        size: 20,
      },
    },
  },
  scheduleTimeFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: scheduleTimeFont,
        mobileSizeOverrideParam: mobileScheduleTimeSize,
        defaults: {fontSize: 16, mobileFontSize: 14},
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  scheduleDurationFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: scheduleDurationFont,
        mobileSizeOverrideParam: mobileScheduleDurationSize,
        defaults: {
          fontSize: 14,
          mobileFontSize: 14,
        },
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  scheduleTitleFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: scheduleTitleFont,
        mobileSizeOverrideParam: mobileScheduleTitleSize,
        defaults: {fontSize: 16, mobileFontSize: 14},
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  scheduleLocationFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: scheduleLocationFont,
        mobileSizeOverrideParam: mobileScheduleLocationSize,
        defaults: {
          fontSize: 14,
          mobileFontSize: 14,
        },
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  ticketPickerListMainFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: ticketPickerListMainFont,
        mobileSizeOverrideParam: mobileTicketsPickerMainFontSize,
        defaults: {
          fontSize: 20,
          mobileFontSize: 20,
        },
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 20,
      },
    },
  },
  ticketPickerCardsMainFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: ticketPickerCardsMainFont,
        mobileSizeOverrideParam: mobileTicketsPickerMainFontSize,
        defaults: {
          fontSize: 20,
          mobileFontSize: 20,
        },
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 20,
      },
    },
  },
  ticketPickerListAdditionalFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: ticketPickerListAdditionalFont,
        mobileSizeOverrideParam: mobileTicketsPickerAdditionalFontSize,
        defaults: {
          fontSize: 14,
          mobileFontSize: 14,
        },
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  ticketPickerCardsAdditionalFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: ticketPickerCardsAdditionalFont,
        mobileSizeOverrideParam: mobileTicketsPickerAdditionalFontSize,
        defaults: {
          fontSize: 14,
          mobileFontSize: 14,
        },
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  headerLayout: {
    type: StyleParamType.Number,
    getDefaultValue: () => HEADER_LAYOUT.CLASSIC,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: HEADER_LAYOUT.CLASSIC,
      },
    },
  },
  headerImageAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => HEADER_IMAGE_ALIGNMENT.LEFT,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: HEADER_IMAGE_ALIGNMENT.LEFT,
      },
    },
  },
  headerAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: () => EventDetailsAlignment.CENTER,
    metadata: {
      type: StyleType.alignItems,
      defaultValue: {
        type: 'static',
        value: EventDetailsAlignment.CENTER,
      },
    },
  },
  contentAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: ({isRTL}) => (isRTL ? EventDetailsAlignment.RIGHT : EventDetailsAlignment.LEFT),
    metadata: {
      type: StyleType.alignItems,
      defaultValue: {
        type: 'static',
        value: EventDetailsAlignment.LEFT, // TODO: add RTL support maybe?
      },
    },
  },
  buttonStyle,
  imageRatio: {
    type: StyleParamType.Number,
    getDefaultValue: () => EventDetailsImageRatio['16:9'],
    metadata: {
      type: StyleType.objectFit,
      defaultValue: {
        type: 'static',
        value: EventDetailsImageRatio['16:9'],
      },
    },
  },
  imageScaling: {
    type: StyleParamType.Number,
    getDefaultValue: () => IMAGE_SCALING.CROP,
    metadata: {
      type: StyleType.objectFit,
      defaultValue: {
        type: 'static',
        value: IMAGE_SCALING.CROP,
      },
    },
  },
  headerBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  evTicketDividerSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  rsvpButtonBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  rsvpButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  rsvpButtonRoundedBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 100,
      },
    },
  },
  formButtonBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  formButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  formButtonRoundedBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 100,
      },
    },
  },
  formSummaryBoxBorderSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  shortDateLocationColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  headerDateColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params => {
      const previousValue = params.getStyleParamValue(stylesParams.shortDateLocationColor)
      return previousValue ?? wixColorParam('color-5')(params)
    },
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'shortDateLocationColor',
        fallback: wixColor(CssColor.WstParagraph2Color),
      },
    },
  },
  shortDateLocationFont,
  headerDateFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: shortDateLocationFont,
        mobileSizeOverrideParam: mobileShortDateTimeSize,
        defaults: {
          fontSize: 18,
          mobileFontSize: 14,
        },
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 18,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  headerLocationColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: params => {
      const previousValue = params.getStyleParamValue(stylesParams.shortDateLocationColor)
      return previousValue ?? wixColorParam('color-5')(params)
    },
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'shortDateLocationColor',
        fallback: wixColor(CssColor.WstParagraph2Color),
      },
    },
  },
  mobileShortDateTimeSize,
  headerLocationFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: shortDateLocationFont,
        mobileSizeOverrideParam: mobileShortDateTimeSize,
        defaults: {
          fontSize: 18,
          mobileFontSize: 14,
        },
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 18,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  dateColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(textColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'textColor',
      },
    },
  },
  mobileTextSize,
  dateFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: textFont,
        mobileSizeOverrideParam: mobileTextSize,
        defaults: {fontSize: 16, mobileFontSize: 14},
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  locationColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(textColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'textColor',
      },
    },
  },
  locationFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: textFont,
        mobileSizeOverrideParam: mobileTextSize,
        defaults: {fontSize: 16, mobileFontSize: 14},
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  shortDateLocationVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  linkColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(linksColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'linksColor',
      },
    },
  },
  linkFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: params =>
      getV2FontDefault({
        params,
        fontParam: textFont,
        defaults: {fontSize: 16, mobileFontSize: 14, staticMobileSize: true, staticDesktopSize: true},
      }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
      mobileDefaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 14,
      },
    },
  },
  textFontV2,
  textColorV2,
  aboutSectionColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(textColorV2),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'textColorV2',
      },
    },
  },
  aboutSectionFontV2: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(textFontV2),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'textFontV2',
      },
    },
  },
  titleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  mobileEventTitleSize,
  titleFont,
  descriptionVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  descriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  mobileDescriptionSize,
  descriptionFont,
  subtitlesColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  mobileSubtitlesSize,
  subtitlesFont,
  textColor,
  textFont,
  evTicketNameColor,
  evTicketNameFont,
  ticketPickerCardsMainColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(evTicketNameColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'evTicketNameColor',
      },
    },
  },
  ticketPickerCardsMainFont,
  ticketPickerListMainColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(evTicketNameColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'evTicketNameColor',
      },
    },
  },
  mobileTicketsPickerTicketNameSize,
  mobileTicketsPickerMainFontSize,
  ticketPickerListMainFont,
  ticketPickerCardsAdditionalColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(textColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'textColor',
      },
    },
  },
  ticketPickerCardsAdditionalFont,
  ticketPickerListAdditionalColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(textColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'textColor',
      },
    },
  },
  mobileTicketsPickerAdditionalFontSize,
  ticketPickerListAdditionalFont,
  ticketPickerCardsBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => {
      const inheritedValue = getStyleParamValue(evBackgroundColor)
      return {
        ...inheritedValue,
        opacity: 1,
      }
    },
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: {
        type: 'ref',
        ref: 'evBackgroundColor',
      },
    },
  },
  ticketPickerCardsBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.3),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  ticketPickerCardsVerticalDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.3),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  ticketPickerListVerticalDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.3),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  ticketPickerListHorizontalDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.3),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  ticketPickerCardsShadowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.12),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  scheduleTimeColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  mobileScheduleTimeSize,
  scheduleTimeFont,
  scheduleDurationColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-4'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph3Color),
    },
  },
  mobileScheduleDurationSize,
  scheduleDurationFont,
  scheduleTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  mobileScheduleTitleSize,
  scheduleTitleFont,
  scheduleLocationColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  mobileScheduleLocationSize,
  scheduleLocationFont,
  headerBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 0.1),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  evBackgroundColor,
  headerBorderOpacityAndColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.3),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  imageOpacity: {
    type: StyleParamType.Number,
    getDefaultValue: () => 100,
    metadata: {
      type: StyleType.opacity,
      defaultValue: {
        type: 'static',
        value: 100,
      },
    },
  },
  colorBehindImage: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-7'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstShade2Color),
    },
  },
  rsvpHollowButtonFont,
  rsvpHollowButtonFontV2,
  secondRsvpHollowButtonFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(rsvpHollowButtonFontV2),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'rsvpHollowButtonFontV2',
      },
    },
  },
  rsvpHollowButtonColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  rsvpButtonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  secondRsvpHollowButtonColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  secondRsvpButtonBorderColor,
  rsvpButtonColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  rsvpButtonFont,
  rsvpButtonFontV2,
  secondRsvpButtonFont: {
    type: StyleParamType.Font,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(rsvpButtonFontV2),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'ref',
        ref: 'rsvpButtonFontV2',
      },
    },
  },
  rsvpButtonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  secondRsvpButtonColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  secondRsvpButtonBackgroundColor,
  membersVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  aboutSectionVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  groupVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  membershipsVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
  },
  socialShareVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  mapVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  scheduleVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  headerRegistrationButtonVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  eventImageVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  pageRegistrationButtonVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  ticketPickerCardsShadowVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  readMoreButtonVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  formSummaryColor,
  formSummaryTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 20,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 20,
      },
    },
  },
  formSummaryBodyFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-S', {
      size: 14,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-S',
        size: 14,
      },
    },
  },
  formSummaryBodyColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(formSummaryColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'formSummaryColor',
      },
    },
  },
  formSummaryBoxBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  formSummaryBoxBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.6),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  formTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  formTitleFont,
  formLabelsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstParagraph2Color),
    },
  },
  formLabelsFont: {
    type: StyleParamType.Font,
    getDefaultValue: getDefaultFont('Body-M', {
      size: 16,
    }),
    metadata: {
      type: StyleType.font,
      defaultValue: {
        type: 'static',
        preset: 'Body-M',
        size: 16,
      },
    },
  },
  formBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  formHollowButtonFont,
  formHollowButtonColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  formFullButtonFont,
  formFullButtonColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: {
      type: StyleType.color,
      defaultValue: wixColor(CssColor.WstPrimaryBackgroundColor),
    },
  },
  formButtonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.borderColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  formButtonStyle: {
    type: StyleParamType.Number,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(buttonStyle),
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'ref',
        ref: 'buttonStyle',
      },
    },
  },
  formButtonBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
    metadata: {
      type: StyleType.backgroundColor,
      defaultValue: wixColor(CssColor.WstLinksAndActionsColor),
    },
  },
  ticketPickerLayout: {
    type: StyleParamType.Number,
    getDefaultValue: () => TICKET_PICKER_LAYOUT.LIST,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: TICKET_PICKER_LAYOUT.LIST,
      },
    },
  },
  ticketPickerListSpacing: {
    type: StyleParamType.Number,
    getDefaultValue: () => 24,
    metadata: {
      type: StyleType.gap,
      defaultValue: {
        type: 'static',
        value: 24,
      },
    },
  },
  ticketPickerCardSpacing: {
    type: StyleParamType.Number,
    getDefaultValue: () => 12,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 12,
      },
    },
  },
  ticketPickerListVerticalDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  ticketPickerCardsVerticalDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  ticketPickerListHorizontalDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  ticketPickerCardsBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 1,
      },
    },
  },
  ticketPickerCardsBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  ticketPickerCardsShadowAngle: {
    type: StyleParamType.Number,
    getDefaultValue: () => 135,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 135,
      },
    },
  },
  ticketPickerCardsShadowDistance: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderWidth,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  ticketPickerCardsShadowBlur: {
    type: StyleParamType.Number,
    getDefaultValue: () => 25,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 25,
      },
    },
  },
  ticketPickerListInputBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  ticketPickerCardsInputBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: {
      type: StyleType.borderRadius,
      defaultValue: {
        type: 'static',
        value: 0,
      },
    },
  },
  responsive: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => undefined,
  },
  linksColor,
  ticketMoreInfoButtonVisible: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true,
    metadata: {
      type: StyleType.booleanValue,
      defaultValue: {
        type: 'static',
        value: true,
      },
    },
  },
  socialShareColorV2: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(textColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'textColor',
      },
    },
  },
  formLinksColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({getStyleParamValue}) => getStyleParamValue(linksColor),
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'ref',
        ref: 'linksColor',
      },
    },
  },
})

export default stylesParams

export {customCssVars} from './custom-css-vars'
